import React, {useMemo, memo} from 'react';
import PropTypes from 'prop-types';
import defaultUser from '../../../assets/images/required/user.png';
import {formatText} from '../../../services/common';

function ReviewSliderSlide({review, language}) {
  const dataByLocale = useMemo(() => {
    const {
      nameEn, nameRu, roleRu, roleEn, textRu, textEn, imageUrl,
    } = review;

    if (language === 'ru') {
      return {
        name: nameRu,
        role: roleRu,
        text: textRu,
        imageUrl,
      };
    }

    if (language === 'en') {
      return {
        name: nameEn,
        role: roleEn,
        text: textEn,
        imageUrl,
      };
    }
    return {};
  }, [review, language]);

  return (
    <div className="swiper-slide">
      <div className="swiper-content">
        <div className="review-item-wrap active">
          <div className="review-item-content">
            <blockquote className="review-item">
              <p dangerouslySetInnerHTML={{__html: formatText(dataByLocale.text)}} />
              <div className="review-user-info">
                <div className="review-user-img-wrap">
                  <div className="review-user-img">
                    <img src={dataByLocale.imageUrl || defaultUser} alt={dataByLocale.name} />
                  </div>
                </div>
                <cite className="review-user-name">
                  {dataByLocale.name}
                  ,
                  <span className="review-user-work">{dataByLocale.role}</span>
                </cite>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}

ReviewSliderSlide.propTypes = {
  review: PropTypes.shape({
    nameEn: PropTypes.string,
    nameRu: PropTypes.string,
    roleRu: PropTypes.string,
    roleEn: PropTypes.string,
    textRu: PropTypes.string,
    textEn: PropTypes.string,
    imageUrl: PropTypes.string,
  }).isRequired,
  language: PropTypes.string.isRequired,
};

export default memo(ReviewSliderSlide);
